import { render, staticRenderFns } from "./SourceList.vue?vue&type=template&id=3b7e1fc5&scoped=true&"
import script from "./SourceList.vue?vue&type=script&lang=js&"
export * from "./SourceList.vue?vue&type=script&lang=js&"
import style0 from "./SourceList.vue?vue&type=style&index=0&id=3b7e1fc5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7e1fc5",
  null
  
)

export default component.exports